import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

import Chip from 'Chip';

const Thank = ({ thankTitleImage, content }) => {
    return (
        <div className={styles.thank}>
            <Chip id="260875" title="特别鸣谢专区标题图" groupName="中国力量" type="struct">
                <div className={styles.thankTitle}>
                    <img src={thankTitleImage} />
                </div>
            </Chip>
            <Chip id="260879" title="特别鸣谢广告图" groupName="中国力量" type="struct">
                <div className={styles.thankBox}>
                    {content?.imageUrl && <img src={content.imageUrl} />}
                </div>
            </Chip>
        </div>
    );
};

Thank.propTypes = {
    thankTitleImage: PropTypes.string,
    content: PropTypes.object
};

export default errorBoundary(Thank);
